export const typeOf = x => Object.prototype.toString.call(x).slice(8, -1)
export const isObject = x => typeOf(x) === 'Object'
export const concatObjects = (x, y) => ({ ...x, ...y })

export async function preloadImage(src) {
  return new Promise((fulfil, reject) => {
    let img = new Image()
    img.src = src
    img.onload = fulfil
    img.onerror = reject
  })
}
const fetchCache = new Map()
export async function fetchAlbum(shopId, albumId, config) {
  let url = `https://cdn.xopify.com/assets/shop/${shopId}/${albumId}.json`

  if (typeof config.getAlbumUrl === 'function') {
    url = config.getAlbumUrl(albumId)
  }

  if (fetchCache.has(url)) {
    return fetchCache.get(url)
  }

  let res = await fetch(`${url}?${Date.now()}`)

  if (res.ok) {
    let json = await res.json()
    // window.album__ = {
    //   original: structuredClone(json),
    //   value: json,
    // }
    fetchCache.set(url, json)
    return json
  } else {
    throw new Error(`Unable to fetch the gallery :: ${res.status}`)
  }
}

export async function fetchGallery(shopId, galleryId, config) {
  let url = `https://cdn.xopify.com/assets/shop/${shopId}/${galleryId}.json`

  if (typeof config.getGalleryUrl === 'function') {
    url = config.getGalleryUrl(galleryId)
  }

  if (fetchCache.has(url)) {
    return fetchCache.get(url)
  }

  let res = await fetch(
    `${url}?${Date.now()}`,
  )

  if (res.ok) {
    let json = await res.json()

    // window.gallery__ = {
    //   original: structuredClone(json),
    //   value: json,
    // }

    fetchCache.set(url, json)
    return json
  } else {
    throw new Error(`Unable to fetch the gallery :: ${res.status}`)
  }
}

export async function fetchProduct(handle) {
  if (!handle) null

  let url = `/products/${handle}.js`
  if (__DEV__) url = `${window._shop.url}${url}`

  let resp = await fetch(url)
  if (!resp.ok) return null

  let productJson = await resp.json()
  return productJson
}

export function getCurrentUrl(queryParams) {
  if (!queryParams) {
    return window.location.href
  }

  let searchParams = new URLSearchParams(window.location.search)

  Object.keys(queryParams).forEach(k => {
    let value = queryParams[k]
    value == null || value === '' ? searchParams.delete(k) : searchParams.set(k, value)
  })

  let newurl =
    window.location.protocol +
    '//' +
    window.location.host +
    window.location.pathname +
    '?' +
    searchParams.toString()
  return newurl
}

export function updateUrlQueryParams(queryParams, replace) {
  if (!queryParams) return

  if (history.pushState) {
    let newurl = getCurrentUrl(queryParams)

    let fn = replace ? 'replaceState' : 'pushState'
    window.history[fn]({ path: newurl }, '', newurl)
  }
}

export function getQueryParams(keys) {
  let searchParams = new URLSearchParams(window.location.search)

  return Array.isArray(keys)
    ? keys.map(k => (typeof k === 'string' ? searchParams.get(k) : null))
    : searchParams.get(keys)
}

export function iterateWithIndex(fn, iterable) {
  let index = 0
  for (const value of iterable) {
    fn(value, index)
    index++
  }

  return iterable
}

function withinViewport(el) {
  var rect = el.getBoundingClientRect()
  let docHeight = window.innerHeight || document.documentElement.clientHeight
  let heightDiff = docHeight - rect.top
  let percentageInViewport = (heightDiff / docHeight) * 100
  console.log({ heightDiff, percentageInViewport })
  return rect.top >= -100
}

// var root = document.querySelector('.XOC_Album_Root')
// var rect = root.getBoundingClientRect()

// console.log({
// withinViewport: withinViewport(root)
// })

export const CONSTS = {
  GLRY_QP: 'xo-gid',
  ALBM_QP: 'xo-aid',
  FILTER_KEY: '__@namespace::filter__',
  EVENT: {
    ALBUM_LOADING: 'ALBUM_LOADING',
    ALBUM_FETCHED: 'ALBUM_FETCHED',
    WIDGET_READY: 'WIDGET_READY',
    GALLERY_LOADING: 'GALLERY_LOADING',
    GALLERY_FETCHED: 'GALLERY_FETCHED',
    GALLERY_SELECTED: 'GALLERY_SELECTED',
    ALBUM_PAGINATED: 'ALBUM_PAGINATED',
    GALLERY_IMG_CHANGED: 'GALLERY_IMG_CHANGED',
    BACK_TO_ALBUM: 'BACK_TO_ALBUM',
  },
}

export function matchObjectTypes(sourceObject, targetObject) {
  Object.keys(sourceObject).forEach(k => {
    let v1 = sourceObject[k]
    let v2 = targetObject[k]

    if (typeOf(v1) !== typeOf(v2)) {
      targetObject[k] = v1
    }
  })

  return targetObject
}

export function createReadableGalleryTitle(title) {
  if (!title) return null
  if (title.trim()[0] !== '[') {
    return title
  }

  let titleParts = title.split(']')
  let titleMeta = titleParts[0]
    .replace('[', '')
    .trim()
    .split(',')
    .map(x => x.trim())
  title = titleParts[1]
  return `${titleMeta.join(' ')} ${title}`
}

export function getGalleryTitle(gallery) {
  if (!gallery) return null

  let title = gallery.title
  return title?.en || title
}
